import React from "react";
import { Box, Typography, Button, Chip } from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

interface SegmentChangeWarningProps {
  oldSegments: string[];
  newSegments: string[];
  onConfirm: () => void;
  onCancel: () => void;
}

export const SegmentChangeWarningContent: React.FC<
  SegmentChangeWarningProps
> = ({ oldSegments, newSegments, onConfirm, onCancel }) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        This action will clear all your final forecast and planner override
        edits. Are you sure you want to continue?
      </Typography>

      <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          Continue & Clear Edits
        </Button>
      </Box>
    </Box>
  );
};
